import classNames from 'classnames';
import React, { useContext } from 'react';

import { network, WidgetProps } from '../config';
import { ManifoldContext } from '../Provider';

interface Props extends WidgetProps {
  prefix?: string;
  className?: string;
  defaultValue?: string;
  isRanked: boolean;
}

// https://docs.manifold.xyz/v/manifold-for-developers/resources/widgets/marketplace-widgets/widgets/listing-widgets#m-listing-price
export const Price = ({
  className,
  defaultValue,
  isRanked,
  listingId,
  prefix,
}: Props) => {
  const { getListingState } = useContext(ManifoldContext);
  const listing = getListingState(listingId);
  const hasBids = listing && !isRanked && listing.bids.length > 0;
  const hasOffers = listing && isRanked && listing.offers.length > 0;
  const isEveryItemUnderOffer =
    listing &&
    isRanked &&
    listing.marketplace.listing?.totalAvailable &&
    listing.marketplace.listing.totalAvailable <= listing.offers.length;

  return (
    <div
      className={classNames(
        'flex items-baseline gap-1 text-neutral-4',
        { 'floor-price': isRanked },
        className,
      )}
    >
      {prefix}
      <div
        className={classNames(
          'flex flex-col',
          hasBids || (hasOffers && isEveryItemUnderOffer) ? 'block' : 'hidden',
        )}
        data-id={listingId}
        data-network={network}
        data-widget="m-listing-price"
      />
      <span
        className={classNames(
          hasBids || (hasOffers && isEveryItemUnderOffer) ? 'hidden' : 'block',
        )}
      >
        {defaultValue}
      </span>
    </div>
  );
};
